<template>
    <div >
        <span>Vue component!</span>
    </div>
</template>

<script type="text/javascript">
import axios from '~/plugins/axios';

export default {
    name: "FormComponent",
    mounted() {
    }
}
</script>

<style scoped>

</style>
